export default __webpack_public_path__ + "static/media/_login-slide-watchlist.9bacbfc8.png";